import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {UsersDgSearchResults} from "../models/datagrid-search-results/users.dg-search-results.model";
import {AppUsersService} from "../providers/app-users.service";

@Injectable()
export class AppUserResolve implements Resolve<UsersDgSearchResults> {
  constructor(private userService: AppUsersService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<UsersDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.userService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'DESC', 'created').pipe(tap(res => {
      if (res && res.results.length > 0) {
        this.appStateService.updateOnDataGridRefreshNeededSubject(res);
      }
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
